<template>
  <div @click="$emit('click')" class="row vendor-row py-1 py-md-2 cursor-pointer">
    <div class="col-24 col-md-12 font-weight-bold text-dark mb-1 mb-md-0">
      {{ product.vendor_name }}
      <div v-if="current" class="text-uppercase">
        <Badge :text="translations.currently_chosen" />
      </div>
    </div>
    <div class="col-16 col-md-8">
      <div class="row">
        <div class="col-24 col-sm-12 text-nowrap">
          {{ chosenVendorVariant ? "" : `${translations.from} ` }}{{ price | currency }}
        </div>
        <div class="col-24 col-sm-12 text-nowrap">
          <span class="d-inline-block d-md-none">{{ translations.delivery }}</span>
          {{ product.shipping }}
          <br />
          <div v-if="product.package_delivery_hint" class="text-muted text-sm">
            {{ translations.package_delivery_hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="text-right col-8 col-md-4">
      <button v-if="current" type="button" class="btn btn-sm" disabled>
        {{ translations.visit }}
      </button>
      <a v-else :href="path" class="btn btn-primary btn-sm">{{ translations.visit }}</a>
    </div>
  </div>
</template>

<script>
import Badge from "./Badge";
import { mapActions } from "vuex";

export default {
  name: "OtherVendorsModalVendorRow",
  components: { Badge },
  props: {
    current: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
    chosenVariants: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    path() {
      if (this.chosenVendorVariant) {
        return this.chosenVendorVariant.url;
      } else {
        return this.product.path;
      }
    },
    price() {
      if (this.chosenVendorVariant) {
        return this.chosenVendorVariant.price;
      } else {
        return Math.min(...this.product.variants.map(variant => variant.price));
      }
    },
    chosenVendorVariant() {
      return this.product.variants.find(variant => this.chosenVariants?.includes(variant.id));
    },
  },
  watch: {
    price(price) {
      this.setSortPrice({ product: this.product, price });
    },
  },
  methods: {
    ...mapActions({ setSortPrice: "otherVendors/setSortPrice" }),
  },
};
</script>
